module.exports = __webpack_public_path__ + "static/media/parradigm.f6ace445.svg";